export enum SupplyResourceSourceType {
  OnDutyAgents = "OnDutyAgents",
  Allocation = "Allocation",
  Vehicle = "Vehicle",
  AdHoc = "AdHoc",
  AgentSchedule = "AgentSchedule"
}
